/**
 * 页面权限
 */
export const TENDER_AUCTION_LIST_PAGE_UUID =
  '0a0425d9-7a53-4799-ab1c-30efecec7730'
